import { useEffect, useRef, useState } from "react";

const ESPERA_MAXIMA_MS = 2000;

/** Foco al primer `h1` de `contenedor`, ahora o en cuanto aparezca (la pantalla nueva puede estar cargando su trozo). */
function enfocarTitulo(contenedor: HTMLElement): () => void {
  function intentar(): boolean {
    const titulo = contenedor.querySelector<HTMLElement>("h1");
    if (!titulo) return false;
    if (!titulo.hasAttribute("tabindex")) titulo.setAttribute("tabindex", "-1");
    titulo.focus();
    return true;
  }
  if (intentar()) return () => undefined;
  const observador = new MutationObserver(() => {
    if (intentar()) observador.disconnect();
  });
  observador.observe(contenedor, { childList: true, subtree: true });
  const limite = setTimeout(() => observador.disconnect(), ESPERA_MAXIMA_MS);
  return () => {
    observador.disconnect();
    clearTimeout(limite);
  };
}

/**
 * Cambio de cliente accesible (interaction.md §2.3): el foco va al `h1` de la pantalla nueva y una región
 * viva (`polite`) dice «Ahora estás en {Cliente}.». Solo al pasar de un cliente a otro, no en la primera carga.
 * Devuelve el texto de la región viva.
 */
export function useAvisoDeCambioDeCliente(slug: string | null, nombre: string | null): string {
  const previo = useRef<string | null>(slug);
  const [aviso, setAviso] = useState("");

  useEffect(() => {
    const anterior = previo.current;
    previo.current = slug;
    if (!anterior || !slug || anterior === slug) return;
    setAviso(`Ahora estás en ${nombre ?? slug}.`);
    const contenedor = document.getElementById("main-content");
    return contenedor ? enfocarTitulo(contenedor) : undefined;
    // `nombre` solo da el texto del aviso: cambiar de nombre sin cambiar de slug no es un cambio de cliente.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  return aviso;
}
